import React from 'react';
import './PoseCard.css';

const PoseCard = ({ pose, isActive, isSelected, isLoading, onSelect }) => {
  const imagePath = `/img/${pose.Number}.jpg`;
  
  return (
    <div 
      className={`pose-card ${isActive ? 'active' : ''} ${isSelected ? 'selected' : ''}`}
      onClick={onSelect}
    >
      <div className="pose-image-container">
        <img 
          src={imagePath} 
          alt={pose.Translation}
          className="pose-image"
        />
        {isLoading && <div className="loading-spinner"></div>}
        {isActive && <div className="active-ring"></div>}
      </div>
      <div className="pose-info">
        <h3 className="pose-title">{pose.Translation}</h3>
        <p className="pose-sanskrit">{pose.Sanskrit}</p>
        <p className="pose-number">#{pose.Number}</p>
      </div>
    </div>
  );
};

export default PoseCard;
